var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2490,
    height: 2500,
    viewBox: "0 0 256 257",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.61 45.74h72.158l36.4 63.049h41.569C246.274 47.342 193.172 .291 129.077 .291c-16.21 0-31.702 3.039-45.978 8.53l22.51 36.92",
    fill: "#006533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.098 146.763l-38.33 66.39H81.112l-48.327-83.706 38.61-66.875-21.332-34.988C20.153 51.047 .913 87.492 .913 128.454c0 70.783 57.381 128.164 128.164 128.164 64.564 0 117.953-47.749 126.84-109.855h-39.82",
    fill: "#82B816"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.51 128.115c0 25.28-20.493 45.773-45.773 45.773-25.28 0-45.772-20.493-45.772-45.773 0-25.28 20.493-45.773 45.772-45.773 25.28 0 45.773 20.493 45.773 45.773",
    fill: "#006532"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradle);
export default __webpack_public_path__ + "static/media/gradle.4887a884b55a2e9549ef25c9474f2e7b.svg";
export { ForwardRef as ReactComponent };